import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button, Dialog, DialogActions } from './ds';
import { isAdmin } from '../utils/roles';
import { FiLogOut, FiSettings } from 'react-icons/fi';
import { useAppNavItems } from '../hooks/useAppNavItems';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const { logout, profile, displayName } = useAuth();
  const navigate = useNavigate();
  const navItems = useAppNavItems(profile);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const admin = isAdmin(profile);

  useEffect(() => {
    if (!showLogoutConfirm) return;
    const onKey = (e) => {
      if (e.key === 'Escape') setShowLogoutConfirm(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [showLogoutConfirm]);

  const handleConfirmLogout = async () => {
    setShowLogoutConfirm(false);
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <>
      <div className={`sidebar ${!isOpen ? 'collapsed' : ''}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">The Menu Co.</h2>
          <button
            type="button"
            className={`hamburger-button ${!isOpen ? 'active' : ''}`}
            onClick={toggleSidebar}
            aria-label="Cerrar menú"
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        <nav className="sidebar-nav" aria-label="Navegación principal">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={20} aria-hidden />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-user-section">
          <div className="user-info">
            <div className="user-details">
              <div className="user-name">{displayName || 'Usuario'}</div>
              <div className="user-role">{admin ? 'Administrador' : 'Usuario'}</div>
            </div>
            <div className="user-actions">
              <NavLink
                to="/settings"
                className={({ isActive }) => `user-action-btn settings-btn ${isActive ? 'active' : ''}`}
                title="Configuración"
              >
                <FiSettings size={16} aria-hidden />
                <span>Configuración</span>
              </NavLink>
              <button
                type="button"
                onClick={() => setShowLogoutConfirm(true)}
                className="user-action-btn logout-btn"
                title="Cerrar sesión"
              >
                <FiLogOut size={16} aria-hidden />
                <span>Cerrar Sesión</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="hamburger-button-collapsed"
        onClick={toggleSidebar}
        aria-label="Abrir menú"
      >
        <span />
        <span />
        <span />
      </button>

      {showLogoutConfirm ? (
        <Dialog
          open
          title="Cerrar sesión"
          onClose={() => setShowLogoutConfirm(false)}
          footer={
            <DialogActions>
              <Button variant="outline" onClick={() => setShowLogoutConfirm(false)}>
                Cancelar
              </Button>
              <Button variant="solid" onClick={handleConfirmLogout}>
                Cerrar sesión
              </Button>
            </DialogActions>
          }
        >
          <p className="text-secondary">¿Está seguro de que desea cerrar sesión?</p>
        </Dialog>
      ) : null}
    </>
  );
};

export default Sidebar;
